'use client';

import { Download } from '@doist/icons/brand';
import { Box, Container, Heading, Text } from '@doist/marketist';
import { Button } from 'app/components/marketist';
import { StartForFreeButton } from 'app/components/start-for-free-button';
import { useTranslation } from 'app/i18n/client';
import cn from 'clsx';
import { googlePlayAndAppStoreReviewCount } from 'config/constants';
import { useLocale } from 'next-intl';
import css from './prefooter.module.css';
export function Prefooter() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'home-teams');
  return <Box className={css.background} data-sentry-element="Box" data-sentry-component="Prefooter" data-sentry-source-file="prefooter.tsx">
            <Container width="base" className={cn([css.container, 'md-pbs-192', 'pbs-128'])} data-sentry-element="Container" data-sentry-source-file="prefooter.tsx">
                <Heading level="2" size="major-xl" data-sentry-element="Heading" data-sentry-source-file="prefooter.tsx">
                    {t('preFooter.title')}
                </Heading>
                <Text size="body-lg" weight="medium" data-sentry-element="Text" data-sentry-source-file="prefooter.tsx">
                    {t('preFooter.reviews', {
          count: googlePlayAndAppStoreReviewCount
        })}
                </Text>
                <Box className={css.buttons} data-sentry-element="Box" data-sentry-source-file="prefooter.tsx">
                    <StartForFreeButton data-sentry-element="StartForFreeButton" data-sentry-source-file="prefooter.tsx" />
                    <Button startIcon={Download} variant="quinary" size="xsmall" href="/downloads" data-sentry-element="Button" data-sentry-source-file="prefooter.tsx">
                        {t('preFooter.downloadButtonText')}
                    </Button>
                </Box>
            </Container>
        </Box>;
}